import { render, staticRenderFns } from "./dxjy.vue?vue&type=template&id=083efaa9&scoped=true&"
import script from "./dxjy.vue?vue&type=script&lang=js&"
export * from "./dxjy.vue?vue&type=script&lang=js&"
import style0 from "./dxjy.vue?vue&type=style&index=0&id=083efaa9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083efaa9",
  null
  
)

export default component.exports